export const GET_MASTER_TAGS = "GET_MASTER_TAGS";
export const GET_MASTER_TAG_BY_ID = "GET_MASTER_TAG_BY_ID";
export const UPDATE_MASTER_TAG = "UPDATE_MASTER_TAG";
export const DELETE_MASTER_TAG = "DELETE_MASTER_TAG";
export const CREATE_MASTER_TAG = "CREATE_MASTER_TAG";
export const GET_PROGRAMS_BY_MASTER_TAG = "GET_PROGRAMS_BY_MASTER_TAG";
